<template>
  <el-card v-loading.lock="loading" class="box-card">
    <div slot="header" class="clearfix">
      <span class="card-header">{{data.judul}}</span>
    </div>
    <div v-if="role=='admin'">
      <vue-editor v-model="data.data" useCustomImageHandler @image-added="saveImage" @image-removed="deleteImage"/>
      <el-button @click="simpan()" style="margin-top:10px">Simpan</el-button>
    </div>
    <div v-else v-html="data.data"></div>
  </el-card>
</template>

<script>
import { database, storage } from '../firebase'
import { VueEditor } from "vue2-editor";

export default {
  data() {
    return {
      data: {
        judul: 'memuat . . .',
        data: 'memuat . . .'
      },
      role: this.$store.state.user.displayName,
      loading: false
    }
  },
  watch: {
    
  },
  props: {
    halaman: String
  },
  components: {
    VueEditor
  },
  mounted() {
    let modulRef = database.ref('isi/'+this.halaman)
    modulRef.on('value', (snapshot) => {
      this.data = snapshot.val()
    })
  },
  methods: {
    rndStr: function (len) {
      let text = " "
      let chars = "abcdefghijklmnopqrstuvwxyz"
      for( let i=0; i < len; i++ ) {
        text += chars.charAt(Math.floor(Math.random() * chars.length))
      }
      return text
    },
    saveImage: function(file, Editor, cursorLocation, resetUploader) {
      
      var formData = new FormData();
      formData.append("image", file);

      var ref = storage.ref(this.rndStr(10))
      ref.put(file)
        .then(() => {
          ref.getDownloadURL()
            .then((downloadURL) => {
              Editor.insertEmbed(cursorLocation, "image", downloadURL);
              this.simpan()
              resetUploader();
            })
            .catch((error) => {
              this.$notify.error({
                title: 'Error',
                message: error
              });
            })
        })
        .catch((error) => {
          this.$notify.error({
            title: 'Error',
            message: error
          });
        })

    },
    deleteImage: function(image) {
      image
    },
    simpan: function() {
      this.loading = true
      var update = {}
      update['isi/'+this.halaman+'/data'] = this.data.data
      database.ref().update(update).then(()=>{
        this.loading = false;
        this.$notify({
          title: 'Sukses',
          message: 'Pembaruan telah tersimpan',
          type: 'success'
        });
      }).catch((error) => {
        this.$notify.error({
          title: 'Error',
          message: error
        });
      })
      
    }
  }
}
</script>
